import { Box, Flex } from '@chakra-ui/react';
import Loading from '@components/Loading';

import type { FunnelStageType, InteractionCardType } from '../types';
import Column from './Column';

type Props = {
  stages: FunnelStageType[],
  interactions: InteractionCardType[],
  loading: boolean,
};

const Board = ({ stages, interactions, loading }: Props) => {
  if (loading && stages.length === 0) return <Loading />;

  if (!loading && stages.length === 0) {
    return (
      <Box textAlign="center" mt={20} color="gray.500">
        Nenhuma etapa de funil habilitada. Configure o funil de vendas para visualizar o quadro.
      </Box>
    );
  }

  return (
    <Box
      opacity={loading ? 0.5 : 1}
      transition="opacity 0.15s ease"
      w="100%"
      minW={0}
      maxW="100%"
      h={{ base: 'auto', md: 'calc(100vh - 7rem)' }}
      overflowX="auto"
      overflowY="hidden"
    >
      <Flex gap={4} h="100%" w="100%" minW="min-content" alignItems="stretch">
        {stages.map((stage) => (
          <Column
            key={stage.id}
            stage={stage}
            interactions={interactions.filter((item) => item.sales_funnel_step_id === stage.id)}
          />
        ))}
      </Flex>
    </Box>
  );
};

export default Board;
